export default __webpack_public_path__ + "static/media/crm-2.dbf354f0.jpg";